var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHighMediumRating({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 283,
    height: 203,
    viewBox: "0 0 283 203",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.8731 27H36.5827C34.3033 27 32.1321 27.9723 30.6143 29.6728L14.0316 48.2515C12.7232 49.7174 12 51.6137 12 53.5786V123.255V192H207.121H233.416C235.696 192 237.868 191.027 239.386 189.326L255.969 170.739C257.277 169.273 258 167.377 258 165.413V95.7453V27H62.8731Z",
    fill: "#F56811",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M267 128V164.836C267 169.786 265.252 174.576 262.063 178.363L249.293 193.527C245.303 198.265 239.425 201 233.23 201H205",
    stroke: "black",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 74L2 53.7792C2 48.8923 3.70438 44.1583 6.81951 40.393L20.7011 23.6137C24.6906 18.7915 30.623 16 36.8816 16L74 16",
    stroke: "black",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.467 22.7545C239.467 22.7545 233.467 22.7545 229.467 22.7545L226.55 2.34579C232.049 2.34579 235.051 2.34498 241.05 2.34574L243.467 22.7545ZM261.761 34.5449C261.761 23.8457 257.05 22.7545 247.55 22.7545L245.55 2.34575C265.05 1.66513 280.467 4.54504 279.467 38.5444L261.761 34.5449ZM261.761 52.0451C261.95 48.2665 261.763 43.0448 261.761 39.5448L279.467 43.5448C279.467 49.4674 279.467 51.5451 279.467 57.0451L261.761 52.0451Z",
    fill: "url(#paint0_linear_18_54)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.154 22.7545C221.155 22.7545 214.034 22.7545 210.034 22.7545L206.55 2.34566C212.049 2.34566 216.051 2.3449 222.05 2.34566L225.154 22.7545Z",
    fill: "url(#paint1_linear_18_54)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18_54",
    x1: 224.721,
    y1: -27.7997,
    x2: 264.364,
    y2: 39.6543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F56811",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F56811"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18_54",
    x1: 224.721,
    y1: -27.7997,
    x2: 264.364,
    y2: 39.6543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F56811",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F56811"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighMediumRating);
export default __webpack_public_path__ + "static/media/high-medium-rating.950a8231f26f6cecdcff7bc501e04723.svg";
export { ForwardRef as ReactComponent };